import { useState } from 'react';
import Ratio from 'react-bootstrap/Ratio';
import Modal from 'react-bootstrap/Modal';
import './video.scss';

function VideoPopup(props) {
  const [show, setShow] = useState(false);

  return (
    <>
      <div className={`tw-relative video-popup case-study gallery-item case-study-style-01 tw-group ${props.theme || ''}`}>
        <button
            className="tw-size-16 tw-z-[5] tw-absolute tw-top-1/2 tw-left-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2  tw-bg-primary/50 tw-rounded-full tw-text-white tw-text-4xl"
            // variant="primary"
            onClick={() => setShow(true)}
          >
          <i className="fas fa-play"/>
        </button>
        {(props?.theme === 'video-style-2') === !props.imageHide || (
          <img
            alt='video-image'
            width={800} height={450}
            className="tw-h-unset tw-w-full tw-aspect-video tw-object-contain"
            src={props.videoImage}
          />
        )}

        <div className="tw-bg-white tw-p-2.5 tw-w-full tw-opacity-0 tw-absolute tw-left-1/2 -tw-bottom-[90px] tw-z-1 -tw-translate-x-1/2  tw-transition-all tw-duration-300 group-hover:tw-bottom-0 group-hover:tw-opacity-100">
        <div
            className="tw-block tw-text-base tw-font-bold tw-text-black tw-uppercase tw-no-underline"
          >
            {props.title}
          </div>
        </div>
      </div>

      <Modal
        show={show}
        size={props.size || 'md'}
        onHide={() => setShow(false)}
        dialogClassName="pgs-video-popup"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Ratio aspectRatio="16x9">
          <video width="320" height="240" controls autoPlay>
            <source src={props.videoURL} type="video/mp4" />
          </video>
          </Ratio>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default VideoPopup;
